import { HtmlH2 } from 'htmlmodule'
import './Heading.css'

export class Heading extends HtmlH2
{
  static class = 'Heading'
}
